import s from "./file_folder_ui.module.css";

export default function FileFolderToggle(props) {
  const { onClick, mode } = props;
  return (
    <div onClick={onClick} className={s.wrapper}>
      <div className={mode === "file" ? s.active_left : s.left}>FILE</div>
      <div className={mode === "folder" ? s.active_right : s.right}>FOLDER</div>
    </div>
  );
}
